import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="apple-footer">
      <div className="mx-auto max-w-6xl px-6 py-10">
        <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
          <div className="flex items-center gap-2">
            <img src="/vizo-logo.png" alt="Vizo" className="h-6 w-6 rounded-lg" />
            <span className="text-sm font-semibold text-white">Vizo</span>
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-4 text-xs">
            <Link to="/" className="apple-link">Home</Link>
            <Link to="/support" className="apple-link">Support</Link>
            <Link to="/privacy" className="apple-link">Privacy</Link>
            <a href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/" target="_blank" rel="noopener noreferrer" className="apple-link">Terms</a>
            <a href="https://apps.apple.com/tr/app/vizo-music-visualizer/id6749325448" target="_blank" rel="noopener noreferrer" className="apple-link">App Store</a>
          </nav>
        </div>
        <div className="mt-8 border-t border-white/10 pt-6 text-center text-xs text-white/40">
          <p>Copyright &copy; 2018–2026 Vizo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
